var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 18H30V13C30 10.2656 32.1875 8 35 8H35.625C36.6406 8 37.5 7.21875 37.5 6.125V2.375C37.5 1.35938 36.6406 0.5 35.625 0.5H35C28.0469 0.5 22.5 6.125 22.5 13V31.75C22.5 33.8594 24.1406 35.5 26.25 35.5H36.25C38.2812 35.5 40 33.8594 40 31.75V21.75C40 19.7188 38.2812 18 36.25 18ZM13.75 18H7.5V13C7.5 10.2656 9.6875 8 12.5 8H13.125C14.1406 8 15 7.21875 15 6.125V2.375C15 1.35938 14.1406 0.5 13.125 0.5H12.5C5.54688 0.5 0 6.125 0 13V31.75C0 33.8594 1.64062 35.5 3.75 35.5H13.75C15.7812 35.5 17.5 33.8594 17.5 31.75V21.75C17.5 19.7188 15.7812 18 13.75 18Z",
    fill: "#9CC841"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote-left.dee8cd7b98dbd3b71e8aa1962a20558c.svg";
export { ForwardRef as ReactComponent };